<template>
    <div v-if="filterNotifications && $route.name !== 'notifications'" id="notification" class="notification" ref="notification">
        <div v-for="(notification, index) in filterNotifications" class="pt-1 pb-2">
            <v-alert
                dense
                flat
                :type="getNotificationType(notification.type_id)"
                :icon="getNotificationIcon(notification.type_id)"
                elevation="0"
                dismissible
                class="mx-1 mb-0 py-3"
            >
                <template v-slot:close="{ toggle }">
                    <v-btn tag="a" icon small @click="dismiss(toggle, notification.id, index)">
                        <v-icon :color="$vuetify.theme.dark ? '#b5bac1' : 'white'" class="alert-close">mdi-close</v-icon>
                    </v-btn>
                </template>
                <span class="whiteText" v-html="getNotificationText(notification)"></span>
            </v-alert>
        </div>
    </div>
</template>

<style scoped></style>

<script>
    import { eventBus } from '~/app';
    import Vue from 'vue';

    export default {
        name: 'app-notification',
        props: {},
        data() {
            return {};
        },
        mounted() {
            console.log('Component %s mounted.', this.$options.name);

            eventBus.$on('updateNotifications', (data) => {
                this.notifications = data;

                this.$store.commit('MenuModule/setNotificationBadge', data);

                eventBus.$emit('pageResize');
            });
        },

        beforeDestroy: function () {
            console.log('Component %s destroyed.', this.$options.name);

            eventBus.$off('updateNotifications');
        },
        methods: {
            dismiss(toggle, id, index) {
                // toggle();
                var removeIndex = this.notifications.map((item) => item.id).indexOf(id);

                Vue.delete(this.notifications, removeIndex);

                this.$store
                    .dispatch('NotificationModule/update', {
                        rows: [{ id: id, is_viewed: 1 }],
                    })
                    .then(() => {});

                if (this.notifications.length === 0) {
                    this.$store.commit('MenuModule/setNotificationBadge', []);
                }

                eventBus.$emit('pageResize');
            },
            getNotificationType(typeId) {
                switch (typeId) {
                    case this.$const.NOTIFICATION_TYPE_INFO:
                        return 'info';
                    case this.$const.NOTIFICATION_TYPE_WARNING:
                        return 'warning';
                    case this.$const.NOTIFICATION_TYPE_ERROR:
                        return 'error';
                    case this.$const.NOTIFICATION_TYPE_NOTIFICATION:
                        return 'notification';
                    default:
                        return '';
                }
            },
            getNotificationIcon(typeId) {
                switch (typeId) {
                    case this.$const.NOTIFICATION_TYPE_INFO:
                        return 'mdi-information-outline';
                    case this.$const.NOTIFICATION_TYPE_WARNING:
                        return 'mdi-alert-outline';
                    case this.$const.NOTIFICATION_TYPE_ERROR:
                        return 'mdi-alert-octagon-outline';
                    default:
                        return '';
                }
            },
            getNotificationText(notification) {
                let text = notification.text_en;
                if (this.$i18n.locale === 'pt') {
                    text = notification.text_pt;
                }

                return text.replace(/<p.*?>/gi, '').replace(/<\/p>/gi, '');
            },
        },
        computed: {
            notifications: {
                get() {
                    return this.$store.state['NotificationModule'].notViewedNotifications;
                },
                set(value) {
                    this.$store.commit('NotificationModule/setNotViewedNotifications', value);
                },
            },
            filterNotifications() {
                let notifications = this.notifications;

                return notifications
                    ? notifications
                          .filter(
                              (notification) =>
                                  notification.type_id !== this.$const.NOTIFICATION_TYPE_NOTIFICATION &&
                                  notification.type_id !== this.$const.NOTIFICATION_TYPE_MESSAGE
                          )
                          .slice(0, 2)
                    : [];
            },
        },
    };
</script>
